import { baseApiService } from './base'
import type { PaginatedParams, PaginatedResponse } from './common'

export interface Study extends Record<string, unknown> {
  id: string
  name: string
}

export type StudiesResponse = PaginatedResponse<Study>
export type StudiesParams = PaginatedParams

export async function getStudies(params: StudiesParams): Promise<StudiesResponse> {
  return baseApiService.fetch<StudiesResponse>('/api/etmf/masterdata/TRIAL', {
    params
  })
}
